export class Timer {
  constructor(listener, resolution) {
    this.startTime = 0;
    this.stopTime = 0;
    this.totalElapsed = 0; // * elapsed number of ms in total
    this.started = false;
    this.listener = listener || null; // * function to receive onTick events
    this.tickResolution = resolution || 500; // * how long between each tick in milliseconds
    this.tickInterval = null;

    // * pretty static vars
    this.onehour = 1000 * 60 * 60;
    this.onemin = 1000 * 60;
    this.onesec = 1000;
  }

  start() {
    const delegate = function (that, method) {
      return function () {
        return method.call(that);
      };
    };
    if (!this.started) {
      this.startTime = new Date().getTime();
      this.stopTime = 0;
      this.started = true;
      this.tickInterval = setInterval(
        delegate(this, this.onTick),
        this.tickResolution
      );
    }
  }

  stop() {
    if (this.started) {
      this.stopTime = new Date().getTime();
      this.started = false;
      let elapsed = this.stopTime - this.startTime;
      this.totalElapsed += elapsed;
      if (this.tickInterval) {
        clearInterval(this.tickInterval);
      }
    }
    return this.getElapsed();
  }

  reset() {
    this.totalElapsed = 0;
    // * if watch is running, reset it to current time
    this.startTime = new Date().getTime();
    this.stopTime = this.startTime;
  }

  restart() {
    this.stop();
    this.reset();
    this.start();
  }

  getElapsed() {
    let elapsed, hours, mins, secs, ms;
    // * if watch is stopped, use that date, else use now
    elapsed = 0;
    if (this.started) {
      elapsed = new Date().getTime() - this.startTime;
    }
    elapsed += this.totalElapsed;

    hours = parseInt(elapsed / this.onehour, 10);
    elapsed %= this.onehour;
    mins = parseInt(elapsed / this.onemin, 10);
    elapsed %= this.onemin;
    secs = parseInt(elapsed / this.onesec, 10);
    ms = elapsed % this.onesec;

    return {
      hours: hours,
      minutes: mins,
      seconds: secs,
      milliseconds: ms,
    };
  }

  setElapsed(hours, mins, secs) {
    this.reset();
    this.totalElapsed = 0;
    this.totalElapsed += hours * this.onehour;
    this.totalElapsed += mins * this.onemin;
    this.totalElapsed += secs * this.onesec;
    this.totalElapsed = Math.max(this.totalElapsed, 0); // * No negative numbers
  }

  toString() {
    let zpad, e;
    zpad = function (no, digits) {
      no = no.toString();
      while (no.length < digits) {
        no = "0" + no;
      }
      return no;
    };
    e = this.getElapsed();
    return (
      zpad(e.hours, 2) + ":" + zpad(e.minutes, 2) + ":" + zpad(e.seconds, 2)
    );
  }

  setListener(listener) {
    this.listener = listener;
  }
  onTick() {
    if (this.listener) {
      this.listener(this);
    }
  }
}
